/** Strict wall-clock conversion: folds and gaps have no implicit resolution. */
export function localDateTimeToIso(value: string, timeZone: string): string | null {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value)) return null;
  const floating = Date.parse(`${value}:00Z`);
  if (!Number.isFinite(floating) || new Date(floating).toISOString().slice(0, 16) !== value) return null;
  try {
    const format = new Intl.DateTimeFormat("en-CA", { timeZone, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" });
    const local = (instant: number) => {
      const parts = Object.fromEntries(format.formatToParts(new Date(instant)).map((part) => [part.type, part.value]));
      return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
    };
    // Collect offsets on both sides of nearby transitions, then verify every
    // candidate against the requested wall clock. Only one match is valid.
    const offsets = new Set<number>();
    for (let hours = -36; hours <= 36; hours += 6) {
      const sample = floating + hours * 3_600_000;
      offsets.add(Date.parse(`${local(sample)}:00Z`) - sample);
    }
    const candidates = [...offsets].map((offset) => floating - offset).filter((instant) => local(instant) === value);
    return candidates.length === 1 ? new Date(candidates[0]!).toISOString() : null;
  } catch { return null; }
}
export function isoToLocalDateTime(iso: string | null, timeZone: string): string {
  if (!iso) return "";
  const parts = Object.fromEntries(new Intl.DateTimeFormat("en-CA", { timeZone, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).formatToParts(new Date(iso)).map((part) => [part.type, part.value]));
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
}
